import baseAPI from '@/http'

const router = 'api/municipio/municipiogruposolucao'

export const cityGroupSolutionAPI = {
  create: (cityGroupSolution) => baseAPI.post(router, cityGroupSolution),
  update: (cityGroupSolution) => baseAPI.put(router, cityGroupSolution),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  get: (id) => baseAPI.get(`${router}/${id}`),
  listByCity: (filtros) => baseAPI.post(`${router}/list-by-municipio`, filtros),
  comboListByCity: (municipioId) => baseAPI.get(`${router}/list-grupo-solucao-by-municipioId/${municipioId}`),
  getByProject: (id) => baseAPI.get(`${router}/get-by-projeto/${id}`),
  groupSolutionStarted: (groupSolutionid) => baseAPI.post(`${router + '/grupo-solucao-iniciado/' + groupSolutionid}`,)
}
